import React from 'react';
import { CourseEntity } from 'Models/Entities';
import PdfCourseAccordion from 'Views/Pages/Pdf/Components/PDFCourseAccordion';
import PdfCourseAccordionItem from 'Views/Pages/Pdf/Components/PDFCourseAccordionItem';
import PdfChipGroup from 'Views/Pages/Pdf/Chip/PDFChipGroup';
import PdfChip from 'Views/Pages/Pdf/Chip/PdfChip';
import PdfWarningBanner from 'Views/Pages/Pdf/Components/PDFWarningBanner';
import { DataIndex } from 'Util/DataIndexUtils';
import { RequisiteWarning } from 'Queries/Hooks/StudyPlan/types';

interface StudyPlanTermProps {
	termName: string;
	courses: CourseEntity[];
	getCourseComponents: (courseId: string) => string[];
	requisiteWarningsByCourseId: DataIndex<RequisiteWarning[]>,
}

const StudyPlanTerm = (props: StudyPlanTermProps) => {
	const {
		termName,
		courses,
		getCourseComponents,
		requisiteWarningsByCourseId,
	} = props;

	return (
		<PdfCourseAccordion
			title={termName}
			items={courses}
			renderItem={item => {
				const courseComponents = getCourseComponents(item.id);
				const courseWarning = requisiteWarningsByCourseId[item.id];

				return (
					<PdfCourseAccordionItem
						course={item}
						label={(
							<PdfChipGroup>
								{
									courseComponents.map(component => (
										<PdfChip label={component} />
									))
								}
							</PdfChipGroup>
						)}
						warning={courseWarning?.map(warning => (
							<PdfWarningBanner
								title={warning.title}
								description={warning.description}
							/>
						))}
					/>
				);
			}}
		/>
	);
};

export default StudyPlanTerm;
